import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../utils/cn';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 rounded-full text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-60 active:scale-[0.98]', {
    variants: {
        variant: {
            primary: 'bg-gradient-to-r from-primary to-secondary text-primary-foreground shadow-soft-md hover:shadow-soft-xl hover:brightness-110',
            secondary: 'bg-secondary/20 text-secondary-foreground border border-secondary/40 hover:bg-secondary/30 hover:border-secondary/60',
            ghost: 'bg-transparent text-foreground hover:bg-muted/60 border border-transparent hover:border-muted/70',
            outline: 'border border-border bg-background/60 text-foreground hover:bg-background/90 hover:border-accent/70',
            glass: 'bg-white/5 text-foreground border border-white/10 backdrop-blur-xl shadow-soft-md hover:bg-white/10',
        },
        size: {
            sm: 'h-8 px-3 text-xs',
            md: 'h-10 px-4 text-sm',
            lg: 'h-12 px-6 text-base',
            icon: 'h-9 w-9 p-0',
        },
    },
    defaultVariants: {
        variant: 'primary',
        size: 'md',
    },
});
export const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (_jsx(Comp, { className: cn(buttonVariants({ variant, size, className })), ref: ref, ...props }));
});
Button.displayName = 'Button';
export { buttonVariants };
